import {Action} from "redux";
import {
	ReportAction, ReportActionWrapper, ReportFilterAction, ReportState, SetFilterAction,
	SetCheckboxFilterAction, UnsetCheckboxFilterAction
} from "./lib";
import {Filters, FilterState, FilterWidgetCheckboxState, ReportTypes} from "./lib2";
import {Axes, DisplayModes} from "./graph-renderer";

const reduceFilterGeneric = <
	AA extends Axes,
	FF extends Filters,
	DD extends DisplayModes,
	RR extends ReportTypes<AA, FF, DD>,
	A extends ReportFilterAction<FF>
>(s: ReportState<AA, FF, DD, RR>, action: A, f: (filter: FilterState, action: A) => FilterState) => {
	const filters = Object.assign({}, s.filters)
	filters[action.filter] = f(filters[action.filter], action)
	return {...s, filters}
}

const setFilterCheckboxUpdater = <FF extends Filters>(filter: FilterState, action: SetCheckboxFilterAction<FF>): FilterWidgetCheckboxState => {
	return {type: "checkbox", checked: [action.value].concat(filter.type == 'checkbox' ? filter.checked : [])}
}

const unsetFilterCheckboxUpdater = <FF extends Filters>(filter: FilterState, action: UnsetCheckboxFilterAction<FF>): FilterWidgetCheckboxState => {
	return {type: "checkbox", checked: (filter.type == 'checkbox' ? filter.checked : []).filter(a => a != action.value)}
}

const reduceFilter = <
	AA extends Axes,
	FF extends Filters,
	DD extends DisplayModes,
	RR extends ReportTypes<AA, FF, DD>
>(s: ReportState<AA, FF, DD, RR>, action: SetFilterAction<FF>) => {
	const filters = Object.assign({}, s.filters)
	filters[action.filter] = Object.assign({}, filters[action.filter], action.filterData)
	return {...s, filters}
}

const reportsReducer = <
	AA extends Axes,
	FF extends Filters,
	DD extends DisplayModes,
	RR extends ReportTypes<AA, FF, DD>
>(
	s: ReportState<AA, FF, DD, RR>,
	action: ReportAction<AA, FF, DD, RR>
): ReportState<AA, FF, DD, RR> => {
	switch (action.type) {
		case "set display mode":
			return {...s, displayMode: action.mode}
		case "set new report data":
			return {...s, reportData: action.data}
		case "set report type":
			return {...s, reportType: action.value}
		case "set filter":
			return reduceFilter(s, action)
		case "set filter checkbox":
			return reduceFilterGeneric(s, action, setFilterCheckboxUpdater)
		case "unset filter checkbox":
			return reduceFilterGeneric(s, action, unsetFilterCheckboxUpdater)
	}
}

const isReportFilter = <AA extends Axes, FF extends Filters, DD extends DisplayModes, RR extends ReportTypes<AA, FF, DD>>(a: Action): a is ReportActionWrapper<AA, FF, DD, RR> => a.type == "report action"

export const reducer = <
	AA extends Axes,
	FF extends Filters,
	DD extends DisplayModes,
	RR extends ReportTypes<AA, FF, DD>
>(s: ReportState<AA, FF, DD, RR>, a: Action): ReportState<AA, FF, DD, RR> => {
	if (isReportFilter<AA, FF, DD, RR>(a)) {
		return reportsReducer(s, a.action)
	}
	return s
}



// WEBPACK FOOTER //
// ./src/lib/report-builder/reducer.ts